import { Dialog } from "@mui/material";
import { Icon } from "@iconify/react";
import { ButtonPrimary } from "../../components/utils";

interface EmailTemplatePreviewDialogProps {
  open: boolean;
  templateName: string;
  content: string;
  kind: "html" | "amp";
  interactive: boolean;
  loading: boolean;
  sendingTest: boolean;
  onSendTest: () => void;
  onClose: () => void;
}

function EmailTemplatePreviewDialog({
  open,
  templateName,
  content,
  kind,
  interactive,
  loading,
  sendingTest,
  onSendTest,
  onClose,
}: EmailTemplatePreviewDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <div className="w-[900px] h-[900px] flex flex-col">
        <div className="px-10 py-5 mt-2 text-lg font-medium border-b stone-700 shrink-0">
          <h6 className="flex justify-between items-center">
            Mock Preview: {templateName?.toUpperCase()}
            <span onClick={onClose} className="cursor-pointer text-base">
              ✕
            </span>
          </h6>
        </div>
        {loading ? (
          <div className="flex items-center justify-center flex-1 text-gray-500">
            Loading preview...
          </div>
        ) : (
          <div className="flex flex-col flex-1 min-h-0 bg-gray-100">
            {kind === "amp" && (
              <div className="px-4 py-2 text-xs text-blue-800 bg-blue-50 border-b border-blue-200">
                {interactive
                  ? "Live AMP preview using the rendered template and sample grants. Preview decisions do not change grant data."
                  : "AMP callbacks are not configured. Configure the AMP action base URL and signing secret to load sample grants."}
              </div>
            )}
            <iframe
              className="w-full flex-1 border-0 bg-white"
              srcDoc={content || "<div>No Preview Available</div>"}
              sandbox={
                kind === "amp"
                  ? "allow-scripts allow-forms allow-same-origin"
                  : "allow-same-origin"
              }
              title={`Mock preview: ${templateName}`}
            />
          </div>
        )}
        <div className="px-6 py-4 border-t shrink-0 flex justify-end">
          <ButtonPrimary
            onClick={onSendTest}
            disabled={
              sendingTest || loading || (kind === "amp" && !interactive)
            }
          >
            {sendingTest
              ? "Sending..."
              : kind === "amp" && !interactive
              ? "AMP Test Unavailable"
              : "Send Test Email to Me"}
          </ButtonPrimary>
        </div>
      </div>
    </Dialog>
  );
}

export default EmailTemplatePreviewDialog;
